<template>
  <div class="address-form">
    <div style="height: 10px"></div>
    <van-cell-group>
      <van-field
        input-align="right"
        v-model="formData.taitou"
        label="发票抬头"
        :error="formValidate && !formData.taitou"
        placeholder="请输入发票抬头"
      />
      <van-field
        input-align="right"
        v-model="formData.shuihao"
        label="税号"
        :error="formValidate && !formData.shuihao" 
        placeholder="请输入税号"
      /> 
      <van-field
        input-align="right"
        v-model="formData.account"
        label="开户行及账号" 
        :error="formValidate && !formData.account"
        placeholder="请输入开户行及账号"
      />
      <van-field
        input-align="right"
        v-model="formData.address"
        label="购买方地址" 
        :error="formValidate && !formData.address"
        placeholder="请输入购买方地址"
      /> 
      <van-field
        input-align="right"
        v-model="formData.phone"
        label="购买方电话"
        :error="formValidate && !formData.phone"
        placeholder="请输入购买方电话"
      />
      <!-- <van-cell title="是否设为默认">
        <van-switch
          size="24px"
          active-color="#FCAB15"
          v-model="formData.is_default"
        />
      </van-cell> -->
    </van-cell-group>

    <div style="padding: 20px; text-align: center">
      
      <van-button round size="large" @click.stop="onScan"  style=" 
  height: 46px;"
        >扫码导入（微信发票抬头）</van-button
      >
    </div>
    <div style="padding: 20px; text-align: center">
      <van-button round size="large" @click.stop="formSave" class="save"
        >保存</van-button
      >
    </div>

    <div
      v-show="area_show"
      style="position: fixed; bottom: 0; z-index: 1000; width: 100%"
    > 
    </div>
  </div>
</template>
<style scoped>
.address-form {
  background: #f8f8f8;
  height: 843px;
}
.van-cell:not(:last-child)::after {
  right: 16px;
}
.save {
  width: 155px;
  height: 46px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
}
</style>
<script>
import Vue from "vue";
    import { Toast } from 'vant';
import { Popup, CellGroup, Cell, Switch, Area } from "vant";
import areaList from "@/utils/area";

export default {
  name: "AddressAdd",
  data() {
    return {
      show: true,
      formData: {
        taitou: "",
        shuihao: "",
        account: "",
        address: "",
        phone: "", 
        is_default: true,
      },
      selectAddress: {},
      areaList: areaList,
      list: [],
      area_show: false,
      formValidate: false,
    };
  },
  mounted() {
    document.title = "新增发票";
    let that = this;
    window.rbMessage = function (data) {
        data = JSON.parse(data);
//                alert(data);
        if(data[0] == 'fapiaoScan'){
            that.scanSuccess(data[1])
        }
    }

  },
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Area.name]: Area,
  },
  methods: {
    onSelect(address) {
      let that = this;
      that.selectAddress = address;
      that.onChange();
    },
    /*onClose() {
                this.showAdd = false;
                this.$emit("onClose", {})
            },*/

    onChange() {
      /*let that = this;
                // console.log('onChange',{ address: that.data.selectAddress, address_id: that.data.selectAddress.id });
                this.$emit("onChange", { address: that.selectAddress, address_id: that.selectAddress.id})
                that.onClose()*/
      // this.$router.push('addresslist');
      this.$router.go(-1);
    }, 
    onScan(){
      Toast('唤起扫码');
      let that = this;
        appEvent({
          name: "scanCode",
          query: { scen:'fapiaoScan' },
        });
    },
    scanSuccess(text){
      this.$api.get(
        "/api/weixin/getFapiaoTaitou",
        { 
          text :text
        },
        (res) => {
          console.log(res);  
          that.formData = {
            taitou: res.data.taitou,
            shuihao: res.data.shuihao,
            address: res.data.address,
            phone: res.data.phone, 
            account: res.data.account, 
            is_default: true,
          }; 
        }
      );
    },
    areaCancel() {
      this.area_show = false;
    },

    formSave: function () {
      let that = this;
      that.formValidate = true;
      console.log("that.formData", that.formData);
      for (let field in that.formData) {
        if (!that.formData[field] && (field == "taitou" || field == "shuihao"  || field =='phone' || field =='account' || field =='address')) {
          return;
        }
      } 
      this.$api.get(
        "/api/user/invoiceAdd",
        {
          //$name, $phone, $address ,$area_key,$province,$city,$county,$is_default=''
          taitou: that.formData.taitou,
          shuihao: that.formData.shuihao,
          address: that.formData.address,
          phone: that.formData.phone,
          account: that.formData.account,
          is_default: that.formData.is_default ? 1 : 2,
        },
        (res) => {
          console.log(res);
          that.selectAddress = res.data;
          that.formValidate = false;
          that.formData = {
            taitou: "",
            shuihao: "",
            address: "",
            phone: "",
            account: "",
            is_default: true,
          };
          that.onChange();
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// InvoiceAdd.vue?7c5453ae